module.exports = __webpack_public_path__ + "static/media/Pedders_logo.464148e2.jpg";